/* eslint-disable react/prop-types */
import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import secureLocalStorage from "react-secure-storage";
import { updateUser } from "../actions/user";
import { signOut } from "../Api/index";
import { colors } from "../brand";

// The one sign-out confirmation, used by the header menu and the sidebar
export default function LogoutDialog({ open, onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [busy, setBusy] = React.useState(false);
  const user = React.useMemo(() => {
    try {
      return JSON.parse(secureLocalStorage.getItem("profile"));
    } catch {
      return null;
    }
  }, []);

  const logout = async () => {
    setBusy(true);
    const loggingOutId = toast.loading("Logging you out...");
    // Mark the user signed out before the session ends, so the call is allowed
    await dispatch(
      updateUser(user?.results?._id, { login: "no", system: "none" }),
    );
    // Ends the shared login, so the other apps are logged out too
    await signOut().catch(() => {});
    dispatch({ type: "LOGOUT" });
    toast.remove(loggingOutId);
    navigate("/reconciliation/login");
    toast.success("Logged out successfully");
  };

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      PaperProps={{ sx: { borderRadius: "16px", width: 400 } }}
    >
      <DialogTitle sx={{ fontWeight: 800 }}>Log out?</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: colors.textSecondary }}>
          {user?.results?.firstName} {user?.results?.lastName}, you will be
          logged out of all CBX apps on this browser.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          onClick={onClose}
          disabled={busy}
          sx={{ textTransform: "none", color: colors.textSecondary }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={logout}
          disabled={busy}
          startIcon={<LogoutIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            backgroundColor: colors.primary,
            "&:hover": { backgroundColor: colors.primaryDark },
          }}
        >
          Log out
        </Button>
      </DialogActions>
    </Dialog>
  );
}
